module.exports = __webpack_public_path__ + "img/ready-to-scan-3.0a9f5790.png";